import * as React from "react";
import {FaStar} from "react-icons/fa";
import {Button, Col, ProgressBar as BootstrapProgressBar, Row} from "react-bootstrap";
import {StarRating} from "../../../components/starRating";
import {useProductRatingStatisticsFragment} from "../../../hooks/useProductRatingStatisticsFragment";
import {useRatingPaginationVariables} from "../../../hooks/useRatingPaginationVariables";
import {useProductRating} from "../../../hooks/useProductRating";
import {useRefsContext} from "../../../utils/refContext";
import {ProgressBarType} from "../../../definitions/types";

export const RatingDistribution = () => {
    const {
        model: {
            count,
            distribution: {
                oneStar,
                twoStar,
                threeStar,
                fourStar,
                fiveStar
            }
        }
    } = useProductRatingStatisticsFragment();

    // If there are no ratings, return an empty fragment to prevent rendering the component and avoid a divide by zero error
    if (count === 0) return <></>;

    return (

        <Row className="reviews-distribution">
            <Col md={4} className="d-flex align-items-center mb-3 mb-md-0">
                <ProductRating/>
            </Col>
            <Col md={8}>
                <div className="mt-3">
                    <Bar model={{count: fiveStar.starCount, percentage: fiveStar.percentage, numeral: 5}}/>
                    <Bar model={{count: fourStar.starCount, percentage: fourStar.percentage, numeral: 4}}/>
                    <Bar model={{count: threeStar.starCount, percentage: threeStar.percentage, numeral: 3}}/>
                    <Bar model={{count: twoStar.starCount, percentage: twoStar.percentage, numeral: 2}}/>
                    <Bar model={{count: oneStar.starCount, percentage: oneStar.percentage, numeral: 1}}/>
                </div>
            </Col>

        </Row>

    );
}

const ProductRating = () => {
    const {count, grade} = useProductRating();

    if (count === 0) return <></>;

    return (
        <div className="review-statistics">
            <span className="review-stars-wrap">
                <StarRating grade={grade}/>
                <span className="review-text">
                    <strong className="review-ratings-total">{grade}</strong>
                    <span className="review-ratings-count">
                        out of <strong>5</strong> | ({count} Ratings)
                    </span>
                </span>
            </span>
        </div>
    )
}

const Bar: React.FC<ProgressBarType> = ({model: {numeral, count, percentage}}) => {
    const {ratingFilterContainerRef} = useRefsContext();
    const {mutations: {filters: {activeStar, toggleStar}}} = useRatingPaginationVariables();

    const onClick = () => {
        ratingFilterContainerRef.current?.scrollIntoView({behavior: 'smooth'});
        return toggleStar(numeral);
    };

    return (
        <div>
            <Button variant="link"
                    className="reviews-percent-button py-1"
                    onClick={onClick}>
                <div className="chart-rating d-flex align-items-center ">
                    <FaStar size={22} className="me-1 text-warning"/>
                    <div className="mt-1">{numeral}</div>
                </div>
                <div className="chart-bar">
                    <BootstrapProgressBar variant="warning"
                                          className={`reviews-percent ${activeStar(numeral) && 'active-star'}`}
                                          now={percentage}/>
                </div>
                <div className="chart-count text-muted ms-2">{count}</div>
            </Button>
        </div>
    );
};